<template>
	<div class="sub-wrap" >
        <div class="singsubmit tobtn gradient" @click="backIndex"  data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
            	我也要算
        </div>
    </div>
</template>

<script>
	export default {

	name: 'fullSection',
	data:function() {
		return {
		}
	},
	mounted:function(){
		var self = this;
		
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
	},
	methods:{
		webReady:function(){
			
		},
		backIndex:function(){
			window.location.href="/mapply/calculatorIndex"
		}
	}
	}
</script>

<style   scoped lang="less">
@import url("../../../assets/less/common.less");
.sub-wrap{
    padding:0 0.42rem;
}
.singsubmit {
        margin-top: 0.4rem;
        height: 1.16rem;
        line-height: 1.16rem;
        border-radius: 1.33333rem;
        background-color: #d4001f;
        color: #fff;
        text-align: center;
        .px2px(font-size, 34px);
        .line {
            position: relative;
            color: #ff3838;
            margin-right: 0.20667rem;
            display: inline-block;
            padding-right: 0.1rem;
            em {
                position: absolute;
                display: inline-block;
                top: 50%;
                left: 0;
                color: #ff3838;
                border-bottom: 1px solid #ff3838;
                z-index: 10;
                width: 100%;
            }
        }
    }
.formwrap .singsubmit {
    margin-top: 1.6rem;
    height: 1.16rem;
    line-height: 1.16rem;
    background-color: rgb(212, 0, 31);
    color: rgb(255, 255, 255);
    text-align: center;
    font-size: 17px;
    border-radius: 1.33333rem;
   
}

.gradient {
    background: linear-gradient(to right, rgb(255, 155, 37), rgb(255, 59, 55));
}
</style>


// WEBPACK FOOTER //
// src/components/calculator/settlementBtn/settlementBtn.vue